// Page inconnue — route catch-all `*` (Phase 96, plan 96-05).
//
// Il n'existait AUCUNE route catch-all avant cette phase : `<Routes>` rendait
// le vide sur un chemin absent, et le repli SPA de Cloudflare Pages le servait
// en 200 sans en-tête ni pied de page. Le soft-404 préexiste donc à la phase ;
// celle-ci le doublerait avec `/en/`, elle doit le fermer.
//
// L'exclusion d'indexation n'est PAS émise ici : `seoLinks` traite déjà tout
// chemin absent de `PUBLIC_ROUTES` comme non indexable (liste blanche par
// défaut, T-96-11). Une seconde source de vérité serait une dérive en attente.
// Refs: phase 96.
import { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import { useLanguage } from '../i18n/LanguageProvider'
import { langFromPath } from '../i18n/urlLang'

export default function NotFound() {
  const { t } = useLanguage()
  // Chemin du ROUTEUR : déjà dépréfixé par le `basename`, donc `/admin/x` aussi
  // bien sous `/admin/x` que sous `/en/admin/x`.
  const { pathname, search } = useLocation()

  // D-08 — l'administration reste française. La branche `/admin` n'est pas
  // rendue sous `basename="/en"` (plan 96-06) : `<Routes>` y rendrait le vide,
  // et c'est ce catch-all qui prend la main. Deux faits imposent la forme de la
  // sortie :
  //   · le prédicat lit `window.location.pathname` — l'URL du DOCUMENT — parce
  //     que `useLocation()` est déjà dépréfixé et ne peut structurellement pas
  //     répondre à « suis-je dans l'arbre anglais ? » ;
  //   · seule une navigation document échappe au `basename`. Un composant de
  //     redirection du routeur serait re-préfixé et boucherait sur lui-même.
  const leaving = langFromPath(window.location.pathname) === 'en' && pathname.startsWith('/admin')

  useEffect(() => {
    // T-96-15 — la cible est le chemin produit par le ROUTEUR, jamais une
    // concaténation d'entrée brute : pas de redirection ouverte possible.
    if (leaving) window.location.replace(`${pathname}${search}`)
  }, [leaving, pathname, search])

  if (leaving) return null

  return (
    <>
      <Header offHome />
      <main className="pt-28 pb-20 px-6">
        <div className="max-w-[720px] mx-auto">
          <h1 className="font-display font-[800] text-[clamp(1.8rem,4vw,2.5rem)] leading-tight tracking-[-0.02em] mb-4">
            {t('notFound.title')}
          </h1>
          <p className="text-text-muted text-lg mb-8">{t('notFound.body')}</p>
          <Link
            to="/"
            className="inline-block bg-accent hover:bg-accent-hover text-[#1a1209] font-medium px-6 py-3 rounded-[4px] transition-all duration-200 hover:-translate-y-px focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-bg"
          >
            {t('notFound.home')}
          </Link>
        </div>
      </main>
      <Footer />
    </>
  )
}
